import { Component } from '@angular/core';
import { ListRendererWidgetBase } from '@capturum/builders/list-renderer';

@Component({
  selector: 'app-import-request-type',
  templateUrl: './import-request-type.component.html',
  styleUrls: ['./import-request-type.component.scss'],
})
export class ImportRequestTypeComponent extends ListRendererWidgetBase {}
